<template>
  <el-row class="homeContainer">
      <!--左侧导航-->
      <aside>
        <p class="skill_info_aside" style="text-align: center;margin-bottom: 0;">
          <span :title="this.$store.state.skillName?this.$store.state.skillName:this.skillInfo.skill_name" class="skill_name">{{ this.$store.state.skillName?this.$store.state.skillName:this.skillInfo.skill_name }}</span>
          <span class="skill_online" v-if="skillInfo.open_skill_type >= 0">{{skillInfo.open_skill_type | openSkillType}}</span></p>
        <el-menu style="max-height: 100%;" @close="handleClose" :default-active="$route.path + '?skillId=' + skillId+'&online='+online" router unique-opened>
          <!--<el-menu-item index="/skillList">
            <span slot="title" class="title-list">技能列表</span>
          </el-menu-item>-->
          <template>
            <el-submenu index="" class="submenu">
              <template slot="title">
                <i class="icon iconfont icon-jinenggailan"></i>
                <span>技能概览</span>
              </template>
              <el-menu-item class="bg-black" :index="'/updateSkill?skillId='+skillId+'&online='+online">
                <!--<i class="icon-jinenggailan"></i>-->
                <span slot="title">基本信息</span>
              </el-menu-item>
              <el-menu-item class="bg-black" :index="'/edition?skillId='+skillId+'&online='+online">
                <!--<i class="el-icon-menu"></i>-->
                <span slot="title">版本管理</span>
              </el-menu-item>
              <el-menu-item class="bg-black" :index="'/generalize?skillId='+skillId+'&online='+online" v-if="skillInfo.open_skill_type != 2">
                <span slot="title">数据概览</span>
              </el-menu-item>
              <el-menu-item class="bg-black" :index="'/propelling?skillId='+skillId+'&online='+online" v-if="skillInfo.open_skill_type != 2">
                <span slot="title">推送申请</span>
              </el-menu-item>
            </el-submenu>
          </template>
          <template>
            <el-submenu index="1" class="submenu" v-if="skillInfo.open_skill_type != 2">
              <template slot="title">
                <i class="iconfont icon-jinengchaungjian"></i>
                <span>技能构建</span>
              </template>
              <el-menu-item class="bg-black" :index="'/intentionList?skillId='+skillId+'&online='+online">
                <!--<i class="el-icon-menu"></i>-->
                <span slot="title">意图</span>
              </el-menu-item>
              <el-menu-item class="bg-black" :index="'/dictionariesList?skillId='+skillId+'&online='+online">
                <!--<i class="el-icon-menu"></i>-->
                <span slot="title">词典</span>
              </el-menu-item>
              <el-menu-item class="bg-black" :index="'/vocabulary?skillId='+skillId+'&online='+online">
                <span slot="title">欢迎/结束语</span>
              </el-menu-item>
            </el-submenu>
          </template>
          <el-menu-item class="bg-black" @click="remove_bg()" :index="'/service?skillId='+skillId+'&online='+online">
            <i class="iconfont icon-peizhifuwu"></i>
            <span slot="title">配置服务</span>
          </el-menu-item>
          <el-menu-item class="bg-black" @click="remove_bg()" :index="'/machineTest?skillId='+skillId+'&online='+online">
            <i class="el-icon-printer" id="machine"></i>
            <span slot="title">真机测试</span>
          </el-menu-item>
          <el-menu-item class="bg-black" @click="remove_bg()" :index="'/test?skillId='+skillId+'&online='+online+'&open_skill_type='+skillInfo.open_skill_type">
            <i class="iconfont icon-xianshangceshi"></i>
            <span slot="title">线上测试</span>
          </el-menu-item>
          <el-menu-item class="bg-black" @click="remove_bg()" :index="'/release?skillId='+skillId+'&online='+online">
            <i class="iconfont icon-fabushangxian"></i>
            <span slot="title">发布上线</span>
          </el-menu-item>
        </el-menu>
      </aside>

      <!--右侧内容区-->
      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </el-col>
        </div>
      </section>

  </el-row>
</template>
<script>
  import $ from 'jquery'
  import qs from 'qs'
  import CommonMethods from '@/mixins/commonMethods'
  import {updateSkillApi, skillName, skillDetailApi, getUserId, nameRepeatApi,signRepeatApi} from '@/api'
  export default {
    mixins: [
      CommonMethods
    ],
    data() {
      return {
        skillInfo:{},
        skillId: '',
        online:''
      }
    },
    created() {
      this.SkillName()
    },
    methods: {
      remove_bg(){
        let ele = $('.submenu.is-opened .el-submenu__title');
        ele.trigger('click');
      },
      async getSkillDetail(data) {//获取技能详情
        let res = await skillDetailApi(data)
        if (res.data.code == 200) {
            // console.log(res.data.data.data)
            this.skillInfo = res.data.data.data
        }
      },

      handleClose(a,b){

      },
//        logout(){
//          let that = this;
//          this.$confirm('确认退出吗?', '提示', {
//            confirmButtonClass: 'el-button--warning'
//          }).then(() => {
//            //确认
//            that.loading = true;
//            API.logout().then(function (result) {
//              that.loading = false;
//              localStorage.removeItem('access-user');
//              localStorage.removeItem('username');
//              localStorage.removeItem('pwd');
//              that.$router.push({ path: '/login' })
//            }, function (err) {
//              that.loading = false;
//              that.$message.error({showClose: true, message: err.toString(), duration: 2000});
//            }).catch(function (error) {
//              that.loading = false;
//              console.log(error);
//              that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
//            });
//          }).catch(() => {});
//        }
//        a() {
//          window.onbeforeunload = function () {
//            return "fdsfdsfsfdsa?";
//          }
//        },
      SkillName() {//获取skillId
//          this.$route.query.skillId ? void(0) : this.$router.push('/skillList')
        this.skillId = this.$route.query.skillId;
//        console.log(this.$route.path)
        this.online=this.$route.query.online;
          this.getSkillDetail(qs.stringify({skill_id: this.$route.query.skillId,online:this.$route.query.online}))
      },
    },
    mounted() {
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  .homeContainer {
    position: relative;
    width: 100%;
    height: 100%;
    .title-list{
      text-align: center;
      color: #000;
      display: inline-block;
      width: 100%;
      &:hover{
        color: #409EFF;
      }
    }
    .el-submenu.is-opened{
      .el-submenu__title{
        border-left: 3px solid #077eec;
        background: #fff;
        color: #000;
        &:hover{
          background: #fff;
        }
      }
    }
    .el-submenu{
      .el-submenu__title{
        border-left: 3px solid #fff;
        &:hover{
          background: #fbfbfb;
          color: #0086ff;
        }
      }
    }
    .el-menu-item.bg-black{
      border-left: 3px solid #fff;
    }
    .el-menu-item.is-active.bg-black{
        color: #0086ff;
    }
    aside {
      position: fixed;
      left: 0;
      top: 60px;
      bottom: 0;
      width: 200px;
      background: #fbfbfb;
      border-right: 1px solid #f7f5f6;
      .el-menu {
        background: #fbfbfb;
        /*height: -moz-calc(100% - 80px);*/
        /*height: -webkit-calc(100% - 80px);*/
        /*height: calc(100% - 80px);*/
        /*border-radius: 0px;*/
        border-right: none;
        .el-menu-item{
          &.is-active{
            background: #fbfbfb;
          }
          &:hover{
            background: #fbfbfb;
            color: #0086ff;
          }
        }
      }

      .skill_name{
        line-height: 60px;
         max-width: 100px;
        font-size: 16px;
         display: inline-block;
         overflow: hidden;
         text-overflow:ellipsis;
         white-space: nowrap;
        vertical-align: middle;
       }
      .skill_online{
        border-radius: 10px;
        border: 1px solid #0086ff;
        padding: 1px 3px;
        color: #0086ff;
        margin-left: 5px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
    .content-container {
      position: absolute;
      left: 230px;
      right: 0;
      top: 60px;
      margin-top: 60px;
      height: calc(100% - 120px);
      background: #fff;
      .content-wrapper {
        box-sizing: border-box;
      }
    }
    .el-submenu__title{
      padding-left: 40px;
    }
    .el-menu-item{
      padding-left: 60px;
    }
    #machine{
      font-size: 16px;
      width:0;
      margin-right:15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue